<span
  istag="item"
  *ngFor="let item of delimitedLabelList; index as i"
  [attr.item-index]="i"
>
  {{ item }}
</span>
